module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand6-e3f29894c3e31fa0d3a55cb269f886a8.jpg";